import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Language, Title } from '@xfeet-workspace/xfeet-api-client/models';
import { TitleApi, LanguageApi } from '@xfeet-workspace/xfeet-api-client/services';


@Injectable({
  providedIn: 'root'
})
export class PublicDataService {

  public languages: Language[] = [];
  public titles: Title[] = [];

  constructor(
    private titleApi: TitleApi,
    private languageApi: LanguageApi
  ) {

  }

  public init() {
    this.titleApi.getManyBaseTitleControllerTitle()
    .subscribe({
      next: (titles) => this.titles = titles as unknown as Title[]
    });

    this.languageApi.getManyBaseLanguageControllerLanguage()
    .subscribe({
      next: (languages) => this.languages = languages as unknown as Language[]
    });
  }
}
